import { NextImage } from '@apeiron/temp'
import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  styled,
  Typography
} from '@mui/material'
import ExpandSVG from '@public/icons/icon-expand.svg'
import { PropsWithChildren } from 'react'

const Icon = styled(NextImage)`
  height: 16px;
  width: 16px;
`

export const FilterSection = styled((props: AccordionProps) => (
  <Accordion disableGutters elevation={0} square {...props} />
))`
  border-bottom: 2px solid black;

  &.MuiAccordion-root {
    display: flow-root;
    background-color: #dfdfdf;
    padding-bottom: 2px;
  }

  &.MuiAccordion-root:before {
    display: none;
  }
`

export const FilterSectionContent = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    padding: 0;
  }
`

export const FilterSectionHeader = styled(props => (
  <AccordionSummary
    aria-label='expand'
    expandIcon={<Icon src={ExpandSVG} />}
    {...props}
  />
))<PropsWithChildren>`
  &.MuiAccordionSummary-root {
    flex-direction: row-reverse;
    min-height: 25px;
    padding-left: 28px;
    margin-top: 8px;
    margin-bottom: 4px;
    background-color: #74726c;
  }

  &.MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper {
    margin-top: 1.5px;
    transform: rotate(90deg);
    &.Mui-expanded {
      transform: rotate(0deg);
    }
  }

  &.MuiAccordionSummary-root .MuiAccordionSummary-content {
    margin-left: 10px;
    margin-top: 0px;
    margin-bottom: 0px;
    overflow: hidden;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }
`

export const FilterSectionTitle = styled('span')`
  flex: 1;

  padding-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FilterTitle = styled(Typography)`
  color: #333333;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
`
